export default "__VITE_ASSET__ChtoRXSp__"